import { MatTableDataSourceExtended } from "@comunicare/comunicare-angular-interfaces";
import { IActivityLog } from "@comunicare/comunicare-interfaces";
import * as moment from "moment";
import { BehaviorSubject } from "rxjs";
import { PatientService } from "src/app/providers/patient.service";

export class LastPatientListDataSource extends MatTableDataSourceExtended<IActivityLog> {
  private loadingSubject = new BehaviorSubject<boolean>(false);

  public loading$ = this.loadingSubject.asObservable();

  sortingDataAccessor = (data: IActivityLog, sortHeaderId: string): string | number => {
    switch (sortHeaderId) {
      case "patient":
        return this.patientService.getFullname(data.patient).toLocaleLowerCase();
      case "date":
        return moment(data.activityDate).unix();
      default:
        return "";
    }
  };

  constructor(public patientService: PatientService) {
    super();
  }

  public clear(): void {
    this.loadingSubject.complete();
  }

  public loadData(activityLog: IActivityLog[]): void {
    this.data = activityLog;
  }
}
